import React from 'react';

import shortid from 'shortid';
import ImgHTML from '../ImgHTML';

export default ({ staticContent, versionPillar, mvp }) => {
  return (
    <section
      className={`container border-bottom border-top pb-3 text-left ${versionPillar &&
        'pt-5 border-bottom-0'}`}
    >
      {versionPillar ? (
        <div className="row">
          <div className="col-md-12 col-md-auto">
            <h2 className="subtitle bigger" style={{ paddingBottom: '36px' }}>
              {staticContent.title}
            </h2>
            <div className={`content ${!mvp ? 'mb-5' : ''} `}>
              <p>{staticContent.subtitle}</p>
            </div>
          </div>
        </div>
      ) : (
        <h2 className="h2 text-center my-5">{staticContent.title}</h2>
      )}
      <div
        className={`d-md-flex flex-wrap ${
          mvp ? 'justify-content-between' : 'justify-content-around'
        } ${versionPillar && 'mt-5'} `}
      >
        {staticContent.singleBox.map(box => (
          <div
            key={shortid.generate()}
            className="col col-md-5 mb-3 single-col"
          >
            <div className="d-flex">
              <ImgHTML
                className="work-with-icon col-3 pl-0"
                alt="Logo"
                title="Logo"
                src={box.src}
              />
              <div className="">
                <h3 className="h6">{box.title}</h3>
                <p className="">{box.subtitle}</p>
              </div>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};
